import React from 'react';

import AmexSecurityDisplay from './AmexSecurityDisplay';
import Explanation from './Explanation';
import DigitNotice from './DigitNotice';

export default () => (
  <div>
    <Explanation>
      The <DigitNotice>4 digits</DigitNotice> on the <em>front</em> of your credit card.
    </Explanation>
    <AmexSecurityDisplay />
  </div>
);
